module.exports = __webpack_public_path__ + "img/23-1.c65bd1f4.png";